import type { ToastOptions } from 'react-toastify';
import { toast } from 'react-toastify';
import type { LabelType } from '../../common/customControls/getServiceLabel';
import { getServiceLabel } from '../../common/customControls/getServiceLabel';
import { ServiceCode } from '../../common/enums/serviceCode';
import { ToastType } from '../../common/enums/toastType';
import { never } from '../../common/utils/never';
import { translateKey } from '../translate';
import { getServiceLabelForCancellingToastMessage } from './getServiceLabelForCancellingToastMessage';

export function showServiceToast(
    toastType: ToastType,
    toastTranslateKey: string | undefined,
    serviceOrServiceCode: { code: ServiceCode } | ServiceCode | undefined,
    labelType: LabelType,
    fallbackMessage: string
) {
    let code: ServiceCode | undefined;
    if (typeof serviceOrServiceCode === 'object') {
        code = serviceOrServiceCode.code;
    } else {
        code = serviceOrServiceCode;
    }

    let toastMessage: string | undefined;
    if (code && toastTranslateKey) {
        let serviceLabel;
        if (toastTranslateKey.match(/^toast\.cancel(Existing)?Success$/)) {
            serviceLabel = getServiceLabelForCancellingToastMessage(code, labelType);
        } else {
            serviceLabel = getServiceLabel(code, labelType);
        }

        if (serviceLabel) {
            serviceLabel = code === ServiceCode.OSASQ ? serviceLabel : serviceLabel.toLowerCase();
            toastMessage = translateKey(toastTranslateKey, serviceLabel);
        }
    }

    if (!toastMessage) {
        toastMessage = fallbackMessage;
    }

    showToast(toastType, toastMessage);
}

export function showToast(toastType: ToastType, message: string) {
    const toastOptions: ToastOptions = {
        position: 'top-right',
        hideProgressBar: true,
    };

    switch (toastType) {
        case ToastType.success:
            toast.success(message, {
                ...toastOptions,
                className: 'alert-success',
            });
            break;
        case ToastType.warning:
            toast.warn(message, {
                ...toastOptions,
                className: 'alert-warning',
            });
            break;
        case ToastType.info:
            toast.info(message, {
                ...toastOptions,
                className: 'alert-info',
            });
            break;
        case ToastType.error:
            toast.error(message, {
                ...toastOptions,
                className: 'alert-danger',
            });
            break;
        case ToastType.default:
            toast(message, {
                ...toastOptions,
                className: 'alert-info',
            });
            break;
        default:
            never(toastType);
    }
}
